import moment from 'moment';
import _ from 'underscore';


const addAssignment = async ({ state, relevantJobs, relevantJobsForCostObject, relatedBranches,
  groupsByBranchAndResource, servicesByDate, activityTypes, updateState }) => {

  updateState({
    relevantJobs, // need to load all dropdown lists into state here to be available in form containers
    relevantJobsForCostObject,
    relatedBranches,
    groupsByBranchAndResource,
    servicesByDate,
    activityTypes
  });

}

export default addAssignment;
